import { render } from "./lngbbd.vue?vue&type=template&id=ec1ef858&scoped=true&ts=true"
import script from "./lngbbd.vue?vue&type=script&lang=ts"
export * from "./lngbbd.vue?vue&type=script&lang=ts"

import "./lngbbd.vue?vue&type=style&index=0&id=ec1ef858&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1ef858"]])

export default __exports__